import React, { useRef, useEffect } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { isScrolledIntoView } from 'lib/dom'
import useAnalytics from 'lib/analytics/useAnalytics'
import {
  EVENT_TEST_DRIVE_SECTION_VIEWED,
  EVENT_TEST_DRIVE_SECTION_CLICKED,
} from 'lib/analytics/events'

import theme from 'theme'
import media from 'media'

import LogoTestDrive from 'components/logo/LogoTestDrive'

import { H4 } from 'lib/ui/primitives'

import StarrySection from 'components/page/Section/StarrySection'
import getStarry from 'lib/ui/starry'

// TODO: move this away from this file, we shouldn't need to run this here
const starry = getStarry({})

const StyledLogoTestDrive = styled(LogoTestDrive)`
  && {
    position: absolute;
    margin-top: 30px;
    margin-left: 30px;
  }
  top: 0;
  left: 0;
`

const StarSection = styled(StarrySection)`
  *:not(.${starry.starClassName}):not(${StyledLogoTestDrive}) {
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    z-index: 10;
    position: relative;
  }

  iframe {
    display: block;
  }

  padding-bottom: 60px;
  display: none;

  ${media.desktop`
    display: block;
  `}
`

const Title = styled(H4)
  .attrs({
    as: 'h2',
  })
  .withConfig({
    shouldForwardProp: (prop) => ['mode'].indexOf(prop) === -1,
  })`
  span {
    color: ${({ mode }) => (mode === 'etch' ? theme.colors.yellow : theme.colors.green)};
  }
`

const Description = styled.div`
  && {
    margin-top: 24px;
    font-size: 16px;
  }
`

export default function TestDriveSection ({
  children,
  title,
  description,
  mode,
  ...others
}) {
  const sectionRef = useRef(null)

  const testDriveViewedEventHandler = useAnalytics({
    eventName: EVENT_TEST_DRIVE_SECTION_VIEWED,
  })
  const testDriveClickedEventHandler = useAnalytics({
    eventName: EVENT_TEST_DRIVE_SECTION_CLICKED,
  })

  const handleViewed = () => {
    testDriveViewedEventHandler({
      mode,
    })
  }

  const handleClick = () => {
    testDriveClickedEventHandler({
      mode,
    })
  }

  useEffect(() => {
    const handleScroll = () => {
      if (isScrolledIntoView({ element: sectionRef.current })) {
        handleViewed()
        window.removeEventListener('scroll', handleScroll)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <StarSection {...others} ref={sectionRef} onClick={handleClick}>
      <Title mode={mode}>{title}</Title>
      <Description>{description}</Description>
      {children}
      <StyledLogoTestDrive />
    </StarSection>
  )
}

TestDriveSection.propTypes = {
  // any 'span' element in the title will be colored green
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node,
  mode: PropTypes.oneOf(['etch', 'pdf-templates']),
}
